import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaMediaObject'

type IcaMediaObjectProps = React.JSX.IntrinsicElements['tgdb-ica-media-object']

export const IcaMediaObject = wrapWc<IcaMediaObjectProps>('tgdb-ica-media-object', [])